import createIcon from '../../createIcon';

/**
 * @component @name PlaylistAddCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk03IDdIMTRWOUg3VjdaTTEwIDE1SDdWMTNIMTBWMTVaTTcgMTJWMTBIMTRWMTJIN1pNMTkgMTVIMTdWMTdIMTVWMTVIMTNWMTNIMTVWMTFIMTdWMTNIMTlWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlaylistAddCircle = createIcon('PlaylistAddCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7 7H14V9H7V7ZM10 15H7V13H10V15ZM7 12V10H14V12H7ZM19 15H17V17H15V15H13V13H15V11H17V13H19V15Z',
      key: 'y5a3db',
    },
  ],
]);

export default PlaylistAddCircle;
